var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_818_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.31033 13.7231L9.23716 8.32554H10.7195L9.79271 13.7231H8.31033ZM15.1504 8.44113C14.8578 8.33092 14.397 8.21533 13.8225 8.21533C12.3564 8.21533 11.3239 8.94648 11.3157 9.9975C11.3076 10.7743 12.0529 11.2044 12.6166 11.4625C13.1938 11.7259 13.3889 11.8953 13.3862 12.1318C13.3835 12.4947 12.9255 12.6587 12.5 12.6587C11.9065 12.6587 11.5922 12.578 11.1044 12.3764L10.912 12.2904L10.7033 13.4973C11.0502 13.6479 11.6897 13.7796 12.3564 13.785C13.9147 13.785 14.9282 13.0619 14.9391 11.941C14.9445 11.3281 14.5488 10.8604 13.6952 10.4733C13.1775 10.2233 12.8605 10.0566 12.8632 9.80396C12.8632 9.58086 13.1315 9.33893 13.7114 9.33893C14.1965 9.33087 14.5488 9.4357 14.8225 9.54591L14.9553 9.60774L15.1504 8.44113ZM18.9662 8.32554H17.8198C17.4648 8.32554 17.1992 8.42231 17.042 8.77444L14.8388 13.7204H16.397C16.397 13.7204 16.6518 13.0565 16.7087 12.9087C16.8794 12.9087 18.3916 12.9113 18.6084 12.9113C18.6518 13.0995 18.79 13.7204 18.79 13.7204H20.1667L18.9662 8.32554ZM17.1477 11.8119C17.2697 11.5001 17.7385 10.3039 17.7385 10.3039C17.7304 10.3174 17.8605 9.99213 17.9363 9.78784L18.0366 10.2529C18.0366 10.2529 18.3212 11.5404 18.3808 11.8119H17.1477ZM7.05016 8.32554L5.59759 12.0055L5.44312 11.2582C5.17211 10.3953 4.3293 9.46258 3.38892 8.99486L4.71683 13.7151L6.28594 13.7124L8.62198 8.32554H7.05016Z",
    fill: "#0E4595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24247 8.3252H1.85222L1.83325 8.43809C3.69504 8.88431 4.92539 9.9649 5.43488 11.2605L4.91726 8.77947C4.82512 8.43809 4.56496 8.33595 4.24247 8.3252Z",
    fill: "#F2AE14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_818_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3333,
    height: 5.56962,
    fill: "white",
    transform: "translate(1.83325 8.21484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visaIcon.197ba643.svg";
export { ForwardRef as ReactComponent };